import { dsConf } from '@kuaizhan/kz-conf';

const conf = {
    host: '',
    api_prefix_v1: '',
    api_prefix_v2: '/v2',
    api_prefix_v3: '',
    url_pic: 'https://pic.kuaizhan.com',
    url_uploaded_pic: 'http://kuaizhantest-1252921496.image.myqcloud.com/',
};

const ds = dsConf(conf);

export default ds;
